module.exports = __webpack_public_path__ + "img/xidada.82533e8f.png";